import { render, staticRenderFns } from "./SelectedPost.vue?vue&type=template&id=49abcca0&scoped=true&"
import script from "./SelectedPost.vue?vue&type=script&lang=js&"
export * from "./SelectedPost.vue?vue&type=script&lang=js&"
import style0 from "./SelectedPost.vue?vue&type=style&index=0&id=49abcca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49abcca0",
  null
  
)

export default component.exports